module.exports = __webpack_public_path__ + "static/media/italic.7e855747.svg";